import React, {lazy, Suspense} from 'react'
import {Router, Switch, Route} from "react-router-dom";
import history from './history'
import ScrollToTop from "./ScrollToTop";
import LoadingPanel from './../components/LoadingPanel'
const Home = lazy(() => import('../views/Route'))

export default (
  <Router history={history}>
    <ScrollToTop/>
    <Suspense fallback={<LoadingPanel full />}>
      <Switch>
        <Route path="/" component={Home} />
      </Switch>
    </Suspense>
  </Router>
)